import React from 'react'

// Import local icons
import sportsbookIcon from '../images/casino-icon/jili-slots.webp'
import jetxIcon from '../images/casino-icon/smartsoft-icon.webp'
import casinoIcon from '../images/casino-icon/red-tiger-icon.webp'
import liveCasinoIcon from '../images//casino-icon/saba-icon.webp'

export const Topbanner = () => {
  // Popular games data with local icons
  const popularGames = [
    {
      id: 'popGame0',
      title: '',
      icon: sportsbookIcon,
      className: 'banner-post'
    },
    {
      id: 'popGame1',
      title: '',
      icon: jetxIcon,
      className: 'banner-post'
    },
    {
      id: 'popGame2',
      title: '',
      icon: casinoIcon,
      className: 'banner-post'
    },
    {
      id: 'popGame3',
      title: '',
      icon: liveCasinoIcon,
      className: 'banner-post'
    }
  ]

  // Function to render game category item
  const renderGameCategory = (game) => (
    <div key={game.id} className="popular-games category-box text-center" id={game.id}>
      <a 
        className={game.className}
        style={{
          backgroundImage: `url(${game.icon})`
        }}
      >
        {game.title}
      </a>
    </div>
  )

  return (
    <div className="main-popular-games">
      <div id="PopularGameCat" className="slider-cat-header">
        <div className="category-scroll-slider card-version">
          {popularGames.map(renderGameCategory)}
        </div>
      </div>
    </div>
  )
}
